export const AuthSortides = ({ auth, handleChange, error }) => {

  return (
                                  <div className="row">
                                  <div className="col col-12 ">
                                    <h4>
                                    Autorització de sortides pedagògiques dins del municipi de Martorell
                                    </h4>
                                    <p>
                                      <input type="radio" id="authSortides1" name="authSortides" value={auth} checked={auth === "1" ? true : false } onChange={ (t) => { handleChange("1") } } required/>
                                      <label htmlFor="authSortides1">
                                        AUTORITZO al meu fill/a a participar a totes les sortides pedagògiques que es realitzin dins la localitat de Martorell, proposades pels departaments didàctics del centre i aprovades pel Consell Escolar.
                                          </label>
                                      <span id="auhtMaterial_ERROR" className="a-Form-error">{error}</span>

                                      <br/>

                                      <input type="radio" id="authSortides0" name="authSortides" value={auth} checked={auth === "0" ? true : false } onChange={ (t) => { handleChange("0") } } required/>
                                      <label htmlFor="authSortides0">
                                       <b>NO</b> AUTORITZO al meu fill/a a participar a totes les sortides pedagògiques que es realitzin dins la localitat de Martorell, proposades pels departaments didàctics del centre i aprovades pel Consell Escolar.
                                          </label>
                                      <span id="auhtMaterial_ERROR" className="a-Form-error">{error}</span>
                                    </p>

                                  </div>
                                </div>
  )
}
